// SETTERS
export const SET_RATES = 'signup/SET_RATES';
export const SET_PLANS = 'signup/SET_PLANS';
export const SET_REFERENCES = 'signup/SET_REFERENCES';
export const SET_QUALS = 'signup/SET_QUALS';
export const SET_REFERENCES_PMK = 'signup/SET_REFERENCES_PMK';
export const SET_LOADIG_REFERENCES = 'signup/SET_LOADIG_REFERENCES';
export const SET_CYCLE = 'signup/SET_CYCLE';
export const SET_COUNTERS = 'signup/SET_COUNTERS';
export const SET_COUPON = 'signup/SET_COUPON';
export const SET_CHECK_EMAIL_EXISTS_WAITING =
  'signup/SET_CHECK_EMAIL_EXISTS_WAITING';
export const SET_CHECK_EMAIL_EXISTS_MESSAGE =
  'signup/SET_CHECK_EMAIL_EXISTS_MESSAGE';
export const SET_CHECK_EMAIL_EXISTS_SUCCESS =
  'signup/SET_CHECK_EMAIL_EXISTS_SUCCESS';
export const SET_SUBSCRIPTION_WAITING = 'signup/SET_SUBSCRIPTION_WAITING';
export const SET_SUBSCRIPTION_MESSAGE = 'signup/SET_SUBSCRIPTION_MESSAGE';
export const SET_SUBSCRIPTION_SUCCESS = 'signup/SET_SUBSCRIPTION_SUCCESS';
export const SET_RATING_EXAM_QUESTIONS = 'signup/SET_RATING_EXAM_QUESTIONS';
export const RESET_COMPONENT = 'signup/RESET_COMPONENT';

// TO SAGAS
export const GET_ALL_PUBLIC_RATES = 'signup/GET_ALL_PUBLIC_RATES';
export const GET_REFERENCES = 'signup/GET_REFERENCES';
export const GET_PLANS = 'signup/GET_PLANS';
export const CHECK_EMAIL_EXISTS = 'signup/CHECK_EMAIL_EXISTS';
export const CHECK_COUPON = 'signup/CHECK_COUPON';
export const MAKE_SUBSCRIPTION = 'signup/MAKE_SUBSCRIPTION';
export const GET_QUALS_DATA = 'signup/GET_QUALS_DATA';
